import "@mui/styled-engine";

import {
  type DialogContentProps,
  IconButton,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import type React from "react";

interface IDialogContentProps extends DialogContentProps {
  element: HTMLElement | null;
}

export const LoadingModalTypo = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  marginBottom: theme.spacing(2),
}));

export const DialogContent = styled<React.FC<IDialogContentProps>>(MuiDialogContent, {
  shouldForwardProp: (prop) => prop !== "element",
})(({ theme, element }) => {
  return {
    overflow: "auto",
    paddingBottom: theme.spacing(3),
    ...(element &&
      element.scrollHeight > element.clientHeight && {
        paddingRight: theme.spacing(1),
      }),
  };
});

export const CloseButton = styled(IconButton)(({ theme }) => ({
  padding: "4px",
  "& svg": {
    fontSize: "32px",
  },
  left: theme.spacing(1),
}));

export const SubTitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

export const DialogActions = styled(MuiDialogActions)(({ theme }) => ({
  padding: `0px ${theme.spacing(3)} ${theme.spacing(3)} ${theme.spacing(3)}`,
}));
